import React from "react"
import PropTypes from "prop-types"

import Item from "./components/Item"
import Error from "./components/Error"

const ParcelsListTableMobile = ({ parcels, errors }) => (
  <div className="visible-xs">
    {parcels.map(parcel => <Item key={parcel.tracking_number} parcel={parcel} />)}
    {errors.map(error => <Error key={error.tracking_number} number={error.tracking_number} />)}
  </div>
)

ParcelsListTableMobile.propTypes = {
  errors: PropTypes.array.isRequired,
  parcels: PropTypes.array.isRequired,
}

export default ParcelsListTableMobile



// WEBPACK FOOTER //
// ./src/views/Parcels/components/ParcelsList/ParcelsListTableMobile/ParcelsListTableMobile.js